import { isFuture, startOfDay } from 'date-fns'
import { TimesheetBalanceFragment } from 'generated/resources/graphql'
import _ from 'lodash'

class ExtraHoursUtils {
  static sumExtraHoursWithinRange({
    balances,
  }: {
    balances?: Array<Pick<TimesheetBalanceFragment, 'extraTimeCalculated' | 'dailyBalance'>> | null
  }): number {
    if (!balances || balances.length === 0) return 0
    const total = balances.reduce((sum, balance) => {
      if (balance.extraTimeCalculated) {
        const calculatedValue = Number(balance.dailyBalance ?? 0)
        if (!Number.isFinite(calculatedValue)) return sum
        return sum + calculatedValue
      }
      return sum
    }, 0)

    return Math.max(total, 0)
  }

  static sumComplementaryTimeWithinRange({
    balances,
  }: {
    balances?: Array<
      Pick<TimesheetBalanceFragment, 'complementaryTimeMinutes' | 'extraTimeCalculated'>
    > | null
  }): number {
    if (!balances || balances.length === 0) return 0
    const total = balances.reduce((sum, balance) => {
      if (balance.extraTimeCalculated) {
        const calculatedValue = Number(balance.complementaryTimeMinutes ?? 0)
        if (!Number.isFinite(calculatedValue)) return sum
        return sum + calculatedValue
      }
      return sum
    }, 0)

    return Math.max(total, 0)
  }

  static isCalculatingExtraHours(balances: TimesheetBalanceFragment[]): boolean {
    const first = _.first(balances)
    const second = _.nth(balances, 1)

    if (!first || !second) return false

    const firstDateEqualToCalculationDate = first.date === first.extraTimeCalculationOn
    const secondDateEqualToCalculationDate = second.date === second.extraTimeCalculationOn

    const dailyFrequency = firstDateEqualToCalculationDate && secondDateEqualToCalculationDate
    if (dailyFrequency) return false

    const lastBalance = _.last(balances)
    if (!lastBalance) return false

    return isFuture(lastBalance.extraTimeCalculationOn)
  }

  static extraHoursCalculationOn(balances: TimesheetBalanceFragment[]): Date {
    const lastBalance = _.last(balances)
    if (!lastBalance) return startOfDay(new Date())

    return new Date(lastBalance.extraTimeCalculationOn)
  }
}

export default ExtraHoursUtils
